import { CalendarDays, Wrench } from "lucide-react";
import { Modal } from "./Modal";
import { fmtDayLabel } from "../utils/calendarHelpers";

export function DayOptionsModal({ date, onClose, onBooking, onMaintenance }) {
  return (
    <Modal title={fmtDayLabel(date)} onClose={onClose} accent="red">
      <div className="space-y-3">
        <p className="text-sm text-slate-500 -mt-1 mb-4">What would you like to do for this date?</p>

        <button
          onClick={onBooking}
          className="w-full flex items-center gap-4 p-4 rounded-lg border hover:border-emerald-300 hover:bg-emerald-50 transition-all text-left group"
          style={{ borderColor: "var(--hx-border)" }}
        >
          <div className="w-11 h-11 rounded-lg bg-emerald-50 group-hover:bg-emerald-100 flex items-center justify-center flex-shrink-0 transition-colors">
            <CalendarDays size={20} className="text-emerald-600" />
          </div>
          <div>
            <div className="font-semibold text-slate-900 text-sm">Add Booking</div>
            <div className="text-xs text-slate-500 mt-0.5">Schedule a client booking for this hoarding</div>
          </div>
        </button>

        <button
          onClick={onMaintenance}
          className="w-full flex items-center gap-4 p-4 rounded-lg border hover:border-blue-300 hover:bg-blue-50 transition-all text-left group"
          style={{ borderColor: "var(--hx-border)" }}
        >
          <div className="w-11 h-11 rounded-lg bg-blue-50 group-hover:bg-blue-100 flex items-center justify-center flex-shrink-0 transition-colors">
            <Wrench size={20} className="text-blue-600" />
          </div>
          <div>
            <div className="font-semibold text-slate-900 text-sm">Schedule Maintenance</div>
            <div className="text-xs text-slate-500 mt-0.5">Plan a repair, inspection, or service window</div>
          </div>
        </button>
      </div>
    </Modal>
  );
}
